(() => {
  const instalmentEl = document.getElementById('instalmentCalc');
  if (!instalmentEl) return;

  const form =
    instalmentEl.closest('product-info')?.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');
  if (!variantIdInput) return;

  // Cache variant prices so we don’t refetch repeatedly
  const priceCache = new Map(); // variantId -> priceRands

  const getQty = () => {
  const qtyInput =
    form.querySelector('input[name="quantity"]') ||
    document.querySelector('input[name="quantity"]');

  const qty = parseInt(qtyInput?.value || '1', 10);
  return Number.isFinite(qty) && qty > 0 ? qty : 1;
};


  const reloadMobicredScript = () => {
    const old = document.getElementById('mobicred-instalment-js');
    if (!old) return;

    const fresh = document.createElement('script');
    fresh.id = 'mobicred-instalment-js';
    fresh.src = 'https://mobicred.co.za/plugins/instalment.js?v=' + Date.now();
    old.parentNode.replaceChild(fresh, old);
  };

  const setWidgetAmount = (unitAmountRands) => {
    const total = unitAmountRands * getQty();
    instalmentEl.dataset.amount = String(total.toFixed(2)); // rands
    instalmentEl.innerHTML = '';
    reloadMobicredScript();
  };

  const fetchVariantPriceRands = async (variantId) => {
    if (priceCache.has(variantId)) return priceCache.get(variantId);

    const res = await fetch(`/variants/${variantId}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Variant fetch failed: ${res.status}`);

    const data = await res.json();
    const priceRands = (data.price || 0) / 100; // cents -> rands
    priceCache.set(variantId, priceRands);
    return priceRands;
  };

  let lastVariantId = null;
  let t;

  const refresh = () => {
    clearTimeout(t);
    t = setTimeout(async () => {
      const variantId = variantIdInput.value;
      if (!variantId) return;

      // Only refetch when variant changes; qty changes reuses cached unit price
      try {
        let unitPrice;
        if (variantId !== lastVariantId) {
          unitPrice = await fetchVariantPriceRands(variantId);
          lastVariantId = variantId;
        } else {
          unitPrice = priceCache.get(variantId);
        }

        // Fallback if something weird happens
        if (typeof unitPrice !== 'number') {
          unitPrice = parseFloat((instalmentEl.dataset.amount || '0').replace(',', '')) || 0;
        }

        setWidgetAmount(unitPrice);
      } catch (err) {
        // If fetch fails, don’t break the page—just keep current output
        console.warn('[Mobicred] refresh failed', err);
      }
    }, 200);
  };

// Quantity changes (robust across themes)
const qtyInput =
  form.querySelector('input[name="quantity"]') ||
  document.querySelector('input[name="quantity"]');

if (qtyInput) {
  // fires when user types, or theme dispatches input
  qtyInput.addEventListener('input', refresh);
  qtyInput.addEventListener('change', refresh);

  // catches themes that change value programmatically (plus/minus)
  const qtyObserver = new MutationObserver(() => refresh());
  qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

  // also catch clicks on any +/- buttons inside the quantity component
  const qtyWrapper = qtyInput.closest('quantity-input') || qtyInput.parentElement;
  qtyWrapper?.addEventListener('click', (e) => {
    const btn = e.target.closest('button');
    if (btn) refresh();
  });
}


  // Variant changes (watch input value via polling — most reliable across themes)
  setInterval(() => {
    const current = variantIdInput.value;
    if (current && current !== lastVariantId) refresh();
  }, 300);

  // Initial render
  refresh();
})();
